import Reflux from 'reflux';
import { Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCoreMixin from 'flux/stores/cuesheet/CuesheetCoreMixin';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetToolbarActions from 'flux/actions/cuesheet/CuesheetToolbarActions';

/**
 * Keeps track of the state necessary for toolbar buttons,
 * and also used to determine what the toolbar buttons should do when pressed
 */
export default Reflux.createStore({
  mixins: [BaseMixin, CuesheetCoreMixin],

  listenables: [CuesheetToolbarActions],

  init() {
    this.setState(
      Map({
        hasFontSize: 'normal',
        hasFontBold: false,
        hasUppercase: false,
        hasFontItalic: false,
        hasFontAlign: 'left',
        foreColor: undefined,
        backColor: undefined,
      }),
    );
    this.listenTo(CuesheetStore, 'onCuesheetChange');
  },

  onCuesheetChange(state) {
    let selectedCells = state.get('selectedCells');

    let itemSetId = this.findFirstItemSetId(state);

    if (!itemSetId) return;

    let toolbarButtonStates = Map().asMutable();

    let formats = selectedCells.map((cell) => this.getCellFormat(cell, state));

    formats.forEach((format) => {
      if (!format) return;

      if (format.get('italic')) toolbarButtonStates.set('hasFontItalic', true);
      if (format.get('bold')) toolbarButtonStates.set('hasFontBold', true);
      if (format.get('uppercase'))
        toolbarButtonStates.set('hasUppercase', true);

      if (format.get('align') === 'left')
        toolbarButtonStates.set('hasFontAlign', 'left');
      if (format.get('align') === 'center')
        toolbarButtonStates.set('hasFontAlign', 'center');
      if (format.get('align') === 'right')
        toolbarButtonStates.set('hasFontAlign', 'right');

      if (format.get('fontSize') === 'small')
        toolbarButtonStates.set('hasFontSize', 'small');
      if (format.get('fontSize') === 'normal')
        toolbarButtonStates.set('hasFontSize', 'normal');
      if (format.get('fontSize') === 'large')
        toolbarButtonStates.set('hasFontSize', 'large');
      if (format.get('fontSize') === 'xlarge')
        toolbarButtonStates.set('hasFontSize', 'xlarge');
    });

    if (formats.size === 1) {
      let first = formats.first();
      if (first) {
        toolbarButtonStates.set('foreColor', first.get('foreColor'));
        toolbarButtonStates.set('backColor', first.get('backColor'));
      }
    }

    this.setStateAndTrigger(toolbarButtonStates.asImmutable());
  },

  onToggleUppercase() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        uppercase: this.getInState('hasUppercase') ? false : true,
      }),
    );
  },

  onToggleBold() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        bold: this.getInState('hasFontBold') ? false : true,
      }),
    );
  },

  onToggleItalic() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        italic: this.getInState('hasFontItalic') ? false : true,
      }),
    );
  },
});
